module.exports = __webpack_public_path__ + "img/39.341ec2f5.jpg";